module.exports = "<nav class=\"header navbar navbar-default navbar-static-top header--settings -left\" id=\"sidebar--nav\">\n<div class=\"container-fluid\">\n    <ul class=\"nav navbar-nav navbar-left\">\n        <li>\n            <a href=\"#\" class=\"settings--close\">\n                <i class=\"icon-left-open-big\"></i>\n            </a>\n        </li>\n        <li>\n            <a href=\"#/settings/general\" class=\"btn-link header--title\">\n                {{_.i18n('Settings')}}\n            </a>\n        </li>\n    </ul>\n</div>\n</nav>\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/settings/sidebar/templates/navbar.html
// module id = 1321
// module chunks = 0